import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { BiEditAlt, BiSolidTrashAlt } from "react-icons/bi";
import { FaPlus } from "react-icons/fa6";
import { LuCalendarClock } from "react-icons/lu";
import { MdOutlineLocationOn, MdOutlineWatchLater } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import CustomButton from "../../component/common/Button/Button";
import { baseURL } from "../../config/apiHandle/apiHandle";
import { GetJobByIdAsync } from "../../services/services";
import { asyncStatus } from "../../utils/asyncStatus";
import { themeOrange } from "../../utils/colorTheme";
import { imgUrl, getImageUrl } from "../../utils/imageUrl";
import {
  error_toast_message,
  success_toast_message,
} from "../../utils/toast_message";
import "./chating.css";
import css from "./VendorDashboard.module.css";

const JobDoneDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:850px)");

  const { get_job_by_id_error, get_job_by_id_data, get_job_by_id_status } =
    useSelector((state) => state.serviceManage);
  const [isShownNegotiation, setIsShownNegotiation] = useState(false);
  const [items, setItems] = useState([]); // Holds the list of items with their prices
  const [item, setItem] = useState({ item_name: "", item_price: "" }); // Holds the current item and its price
  const [editingIndex, setEditingIndex] = useState(null); // Index of the item being edited
  const [isUpdating, setIsUpdating] = useState(false);
  const [isUpdatingJobStatus, setisUpdatingJobStatus] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  // Initialize items with existing add-ons when data loads
  useEffect(() => {
    if (get_job_by_id_data?.order) {
      const addOns = get_job_by_id_data.order.add_ons;
      if (addOns && Array.isArray(addOns) && addOns.length > 0) {
        const existingAddons = addOns.map((addon) => ({
          name: addon.name,
          price: addon.price,
        }));
        setItems(existingAddons);
      } else {
        // Clear items if add_ons is empty or null
        setItems([]);
      }
    }
  }, [get_job_by_id_data]);

  // Function to check if job can be completed based on date and time
  const canCompleteJob = () => {
    const order = get_job_by_id_data?.order;

    // Check if order status is "Assigned"
    if (order?.status !== "Assigned") {
      return { canComplete: false, reason: "Job status is not assigned" };
    }

    // Check if date_time_lock exists
    if (!order?.date_time_lock) {
      return { canComplete: false, reason: "No confirmed date and time" };
    }

    // const currentTime = new Date();
    // const [year, month, day] = order.date_time_lock.date.split('-');
    // const jobDate = new Date(year, month - 1, day);
    // const jobShift = order.date_time_lock.shift;

    // // Reset time to start of day for accurate date comparison
    // const currentDateOnly = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate());
    // const jobDateOnly = new Date(jobDate.getFullYear(), jobDate.getMonth(), jobDate.getDate());

    // console.log("Current Date:", currentDateOnly);
    // console.log("Job Date:", jobDateOnly);
    // console.log("Job Shift:", jobShift);

    // // If job date is in the future, can't complete
    // if (jobDateOnly > currentDateOnly) {
    //   return {
    //     canComplete: false,
    //     reason: `Job is scheduled for ${format(jobDate, "MMM d, yyyy")}. Cannot complete before the scheduled date.`
    //   };
    // }

    // // If job date is today, check the shift timing
    // if (jobDateOnly.getTime() === currentDateOnly.getTime()) {
    //   const currentHour = currentTime.getHours();
    //   const currentMinutes = currentTime.getMinutes();
    //   const currentTimeInMinutes = currentHour * 60 + currentMinutes;

    //   console.log("Current Hour:", currentHour);
    //   console.log("Current Time in Minutes:", currentTimeInMinutes);

    //   switch (jobShift?.toLowerCase()) {
    //     case "morning":
    //       // Morning shift: 9 AM - 1 PM, can complete after 9 AM
    //       const morningStartTime = 9 * 60; // 9:00 AM in minutes
    //       if (currentTimeInMinutes < morningStartTime) {
    //         return {
    //           canComplete: false,
    //           reason: "Morning shift starts at 9:00 AM. Please wait until the shift begins."
    //         };
    //       }
    //       break;

    //     case "afternoon":
    //       // Afternoon shift: 1 PM - 6 PM, can complete after 1 PM
    //       const afternoonStartTime = 13 * 60; // 1:00 PM in minutes
    //       if (currentTimeInMinutes < afternoonStartTime) {
    //         return {
    //           canComplete: false,
    //           reason: "Afternoon shift starts at 1:00 PM. Please wait until the shift begins."
    //         };
    //       }
    //       break;

    //     case "evening":
    //       // Evening shift: 6 PM onwards, can complete after 6 PM
    //       const eveningStartTime = 18 * 60; // 6:00 PM in minutes
    //       if (currentTimeInMinutes < eveningStartTime) {
    //         return {
    //           canComplete: false,
    //           reason: "Evening shift starts at 6:00 PM. Please wait until the shift begins."
    //         };
    //       }
    //       break;

    //     default:
    //       // If shift is not recognized, allow completion
    //       console.warn("Unknown shift:", jobShift);
    //       break;
    //   }
    // }

    // // If job date is in the past, can complete
    // if (jobDateOnly < currentDateOnly) {
    //   return { canComplete: true, reason: "" };
    // }

    // If job date is today and shift time has passed, can complete
    return { canComplete: true, reason: "" };
  };

  const completionStatus = canCompleteJob();

  // Add or update an item in the list and immediately update the order price
  const _handleNegotiationPrice = async (e) => {
    e.preventDefault();

    if (item.item_name && item.item_price) {
      const newItem = {
        name: item.item_name,
        price: parseFloat(item.item_price),
      };

      let updatedItems;
      // If editing an item, update the item in the list
      if (editingIndex !== null) {
        updatedItems = [...items];
        updatedItems[editingIndex] = newItem;
        setEditingIndex(null); // Reset editingIndex after updating
      } else {
        // If not editing, just add a new item
        updatedItems = [...items, newItem];
      }

      setItems(updatedItems);
      // Clear the input fields after adding or updating
      setItem({ item_name: "", item_price: "" });

      // Immediately update the order price on the server
      try {
        setIsUpdating(true);

        const payload = {
          addons: updatedItems.map((addon) => ({
            name: addon.name,
            price: addon.price,
            service_id: get_job_by_id_data?.order?.id,
          })),
        };

        const response = await axios.post(
          `${baseURL}/orders/${id}/addons`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        console.log("Order price updated successfully:", response.data);
        success_toast_message("Item added and price updated!");
        dispatch(GetJobByIdAsync(id));
      } catch (error) {
        console.error("Error updating order price:", error);
        error_toast_message("Failed to update order price. Please try again.");
      } finally {
        setIsUpdating(false);
      }
    }
  };

  // Delete an item from the list and immediately update the order price
  const _deleteItem = async (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);

    // Immediately update the order price on the server
    try {
      setIsUpdating(true);

      const token = localStorage.getItem("auth") || "";

      const payload = {
        addons: newItems.map((addon) => ({
          name: addon.name,
          price: addon.price,
          service_id: get_job_by_id_data?.order?.id,
        })),
      };

      const response = await axios.post(
        `${baseURL}/orders/${id}/addons`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      success_toast_message("Item removed!");
      // Don't refresh - keep local state
    } catch (error) {
      alert("ERROR: " + (error.response?.data?.message || error.message));
      error_toast_message("Failed to remove item. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  // Edit an item in the list
  const _editItem = (index) => {
    setEditingIndex(index);
    setItem({
      item_name: items[index].name,
      item_price: items[index].price.toString(),
    });
  };

  // Calculate the total price
  const totalAmount = items.reduce((acc, item) => acc + item.price, 0);
  const getAuthToken = () => {
    return localStorage.getItem("auth") || "";
  };
  const authToken = getAuthToken();

  const handleUpdateOrderPrice = async () => {
    try {
      setIsUpdating(true);

      const payload = {
        addons: items.map((item) => ({
          name: item.name,
          price: item.price,
          service_id: get_job_by_id_data?.order?.id, // Using the service_id from the item
        })),
      };

      const response = await axios.post(
        `${baseURL}/orders/${id}/addons`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`, // Include auth token in header
          },
        }
      );
      setItems([]);
      setItem({ item_name: "", item_price: "" });
      setIsShownNegotiation(false);
      console.log("Order price updated successfully:", response.data);
      success_toast_message("Order price updated successfully!");

      dispatch(GetJobByIdAsync(id));
    } catch (error) {
      console.error("Error updating order price:", error);
      error_toast_message("Failed to update order price. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  const approveJob = async () => {
    // Double check before API call
    if (!completionStatus.canComplete) {
      error_toast_message(completionStatus.reason);
      return;
    }

    try {
      setisUpdatingJobStatus(true);
      const payload = {
        addons: items.map((item) => ({
          name: item.name,
          price: item.price,
          service_id: get_job_by_id_data?.order?.id, // Using the service_id from the item
        })),
        status: "Completed",
      };

      const response = await axios.post(
        `${baseURL}/orders/${id}/addons`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`, // Include auth token in header
          },
        }
      );

      console.log("Order completed successfully:", response.data);
      success_toast_message("Job Completed Successfully!");

      // Navigate to completed jobs tab after a short delay
      setTimeout(() => {
        navigate("/dashboard/job-done?tab=completed");
      }, 1000);
    } catch (error) {
      console.error("Error completing job:", error);
      error_toast_message("Failed to complete job. Please try again.");
    } finally {
      setisUpdatingJobStatus(false);
    }
  };

  useEffect(() => {
    if (get_job_by_id_data?.order?.add_ons) {
      const existingAddons = get_job_by_id_data.order.add_ons.map((addon) => ({
        name: addon.name,
        price: addon.price,
      }));
      setItems(existingAddons);
    }
  }, [get_job_by_id_data]);

  useEffect(() => {
    dispatch(GetJobByIdAsync(id));
  }, []);

  const loading = get_job_by_id_status === asyncStatus.LOADING;

  console.log(get_job_by_id_data || "");
  let order = get_job_by_id_data?.order;

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  const negotiationRef = useRef();
  useEffect(() => {
    if (isMobile) {
      if (isShownNegotiation && negotiationRef.current) {
        const timeout = setTimeout(() => {
          negotiationRef.current.scrollIntoView({ behavior: "smooth" });
        }, 100);
        return () => clearTimeout(timeout);
      }
    }
  }, [isShownNegotiation]);

  const handlenavigation = () => {
    setIsShownNegotiation(!isShownNegotiation);
  };

  console.log(isShownNegotiation, "isShownNegotiation");

  // Shared pricing calc helpers
  const svcAmt = order?.service_amount || 0;
  const addonsTotal = items.reduce((s, a) => s + (a.price || 0), 0);
  const subtotal = svcAmt + addonsTotal;
  const tax = subtotal * 0.13;
  const grandTotal = subtotal + tax;

  // Shared negotiation form
  const NegotiationForm = ({ inputRef }) => (
    <Stack gap={2}>
      <form onSubmit={_handleNegotiationPrice} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <input
          required
          type="text"
          placeholder="Item name (e.g. Extra parts)"
          className="negotiation_input"
          value={item.item_name}
          onChange={(e) => setItem({ ...item, item_name: e.target.value })}
          style={{ width: "100%", fontSize: "14px", borderRadius: "10px", padding: "12px 14px", border: "1px solid #e5e5e5" }}
        />
        <input
          required
          type="number"
          placeholder="Price ($)"
          className="negotiation_input"
          value={item.item_price}
          onChange={(e) => setItem({ ...item, item_price: e.target.value })}
          style={{ width: "100%", fontSize: "14px", borderRadius: "10px", padding: "12px 14px", border: "1px solid #e5e5e5" }}
        />
        <button
          ref={inputRef}
          type="submit"
          style={{
            background: "linear-gradient(135deg, #F15A24 0%, #C53F10 100%)",
            color: "white", border: "none", borderRadius: "10px",
            padding: "12px", fontWeight: 600, fontSize: "14px",
            cursor: "pointer", display: "flex", alignItems: "center",
            justifyContent: "center", gap: "8px",
          }}
        >
          <FaPlus size={12} />
          {editingIndex !== null ? "Update Item" : "Add Item"}
        </button>
      </form>

      {items.length > 0 && (
        <Stack gap={1.5}>
          <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.8px" }}>
            Added Items
          </Typography>
          {items.map((itm, index) => (
            <Stack
              key={index}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ backgroundColor: "#f8fafc", borderRadius: "10px", px: 2, py: 1.5, border: "1px solid #f0f0f0" }}
            >
              <Stack flex={1}>
                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>{itm.name}</Typography>
                <Typography sx={{ fontSize: "13px", color: themeOrange, fontWeight: 600 }}>${itm.price.toFixed(2)}</Typography>
              </Stack>
              <Stack direction="row" gap={0.5}>
                <IconButton size="small" onClick={() => _editItem(index)} sx={{ color: "#3b82f6" }}>
                  <BiEditAlt size={16} />
                </IconButton>
                <IconButton size="small" onClick={() => _deleteItem(index)} sx={{ color: "#ef4444" }}>
                  <BiSolidTrashAlt size={16} />
                </IconButton>
              </Stack>
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  );

  return (
    <Box sx={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Stack gap={3}>

          {/* ── Page Header ── */}
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography sx={{ fontSize: { xs: "22px", sm: "26px" }, fontWeight: 700, color: "#1a1a1a", letterSpacing: "-0.02em" }}>
              Job Details
            </Typography>
            <Chip
              label={order?.status || "—"}
              sx={{
                backgroundColor:
                  order?.status === "Completed" ? "#10b981" :
                  order?.status === "Assigned"  ? "#3b82f6" : "#f59e0b",
                color: "white", fontWeight: 700, fontSize: "13px",
                px: 1.5, borderRadius: "8px", height: "auto", py: 0.5,
              }}
            />
          </Stack>

          {loading ? (
            <Stack alignItems="center" justifyContent="center" sx={{ height: "60vh" }}>
              <CircularProgress size={30} sx={{ color: themeOrange }} />
            </Stack>
          ) : (
            <Grid container spacing={3}>

              {/* ══════════ LEFT / MAIN COLUMN ══════════ */}
              <Grid item xs={12} lg={isShownNegotiation && !isMobile ? 8 : 12}>
                <Stack gap={3}>

                  {/* ── Hero Card ── */}
                  <Box sx={{
                    borderRadius: "20px", overflow: "hidden",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
                    background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
                  }}>
                    <Stack direction={isMobile ? "column" : "row"}>
                      {/* Service image */}
                      <Box sx={{ width: isMobile ? "100%" : "200px", height: isMobile ? "180px" : "auto", minHeight: "180px", flexShrink: 0 }}>
                        <img
                          src={getImageUrl(order?.service?.mobile_image)}
                          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                        />
                      </Box>
                      {/* Info */}
                      <Stack sx={{ p: 3, flex: 1, gap: 2 }} justifyContent="center">
                        <Stack>
                          <Typography sx={{ color: "rgba(255,255,255,0.45)", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px" }}>
                            Service
                          </Typography>
                          <Typography sx={{ color: "#fff", fontSize: { xs: "18px", sm: "22px" }, fontWeight: 700 }}>
                            {order?.service?.name || ""}
                          </Typography>
                        </Stack>

                        {/* Date row */}
                        {order?.date_time_lock ? (
                          <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap"
                            sx={{ backgroundColor: "rgba(255,255,255,0.08)", borderRadius: "10px", px: 2, py: 1.5 }}>
                            <LuCalendarClock style={{ color: themeOrange, fontSize: "17px", flexShrink: 0 }} />
                            <Typography sx={{ color: "#fff", fontSize: "13px", fontWeight: 500, flex: 1 }}>
                              {(() => {
                                const [y, m, d] = order.date_time_lock.date.split("-");
                                return format(new Date(y, m - 1, d), "EEE, MMM d, yyyy");
                              })()} · {order.date_time_lock.shift}
                            </Typography>
                            <Chip label="CONFIRMED" size="small" sx={{ backgroundColor: themeOrange, color: "white", fontSize: "9px", fontWeight: 700, height: "20px" }} />
                          </Stack>
                        ) : (
                          <Stack direction="row" alignItems="center" gap={1.5}
                            sx={{ backgroundColor: "rgba(255,255,255,0.06)", borderRadius: "10px", px: 2, py: 1.5 }}>
                            <LuCalendarClock style={{ color: "#666", fontSize: "17px" }} />
                            <Typography sx={{ color: "rgba(255,255,255,0.4)", fontSize: "13px", fontStyle: "italic" }}>
                              No confirmed date yet
                            </Typography>
                          </Stack>
                        )}

                        {/* Location row */}
                        <Stack direction="row" alignItems="flex-start" gap={1.5}
                          sx={{ backgroundColor: "rgba(255,255,255,0.08)", borderRadius: "10px", px: 2, py: 1.5 }}>
                          <MdOutlineLocationOn style={{ color: themeOrange, fontSize: "17px", flexShrink: 0, marginTop: "1px" }} />
                          <Typography sx={{ color: "#fff", fontSize: "13px", fontWeight: 500, wordBreak: "break-word" }}>
                            {order?.location || "No location provided"}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Box>

                  {/* ── Description + Customer (side by side on md+) ── */}
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={order?.user?.first_name && order?.status !== "Completed" ? 6 : 12}>
                      <Box sx={{ backgroundColor: "white", borderRadius: "16px", p: 3, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0", height: "100%" }}>
                        <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#1a1a1a", mb: 1.5 }}>
                          Job Description
                        </Typography>
                        <Typography sx={{ color: order?.description ? "#555" : "#bbb", fontSize: "14px", lineHeight: 1.8, fontStyle: order?.description ? "normal" : "italic" }}>
                          {order?.description || "No description provided by customer"}
                        </Typography>
                      </Box>
                    </Grid>

                    {order?.user?.first_name && order?.status !== "Completed" && (
                      <Grid item xs={12} md={6}>
                        <Box sx={{ backgroundColor: "white", borderRadius: "16px", p: 3, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0", height: "100%" }}>
                          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#1a1a1a", mb: 2 }}>
                            Customer
                          </Typography>
                          <Stack gap={2}>
                            <Stack direction="row" alignItems="center" gap={1.5}>
                              <Box sx={{ width: 44, height: 44, borderRadius: "50%", backgroundColor: themeOrange, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <Typography sx={{ color: "white", fontSize: "17px", fontWeight: 700 }}>
                                  {order?.user?.first_name?.[0]?.toUpperCase() || "U"}
                                </Typography>
                              </Box>
                              <Stack>
                                <Typography sx={{ fontSize: "15px", fontWeight: 600, color: "#1a1a1a" }}>
                                  {order?.user?.first_name} {order?.user?.last_name}
                                </Typography>
                                <Typography sx={{ fontSize: "12px", color: "#aaa" }}>Customer</Typography>
                              </Stack>
                            </Stack>
                            <Box sx={{ height: "1px", backgroundColor: "#f5f5f5" }} />
                            {[
                              { label: "Email", value: order?.user?.email },
                              { label: "Phone", value: order?.user?.phone },
                            ].filter(x => x.value).map(({ label, value }) => (
                              <Stack key={label} gap={0.3}>
                                <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "#bbb", textTransform: "uppercase", letterSpacing: "0.5px" }}>{label}</Typography>
                                <Typography sx={{ fontSize: "14px", color: "#444", wordBreak: "break-all" }}>{value}</Typography>
                              </Stack>
                            ))}
                          </Stack>
                        </Box>
                      </Grid>
                    )}
                  </Grid>

                  {/* ── Timing Constraints ── */}
                  {order?.time && (
                    <Box sx={{ backgroundColor: "white", borderRadius: "16px", p: 3, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0" }}>
                      <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#1a1a1a", mb: 1.5 }}>
                        Timing Constraints
                      </Typography>
                      <Stack direction="row" alignItems="flex-start" gap={1.5}>
                        <MdOutlineWatchLater style={{ color: themeOrange, fontSize: "17px", flexShrink: 0, marginTop: "2px" }} />
                        <Typography sx={{ color: "#555", fontSize: "14px", lineHeight: 1.7 }}>{order.time}</Typography>
                      </Stack>
                    </Box>
                  )}

                  {/* ── Attached Photos ── */}
                  {order?.images?.length > 0 && (
                    <Box sx={{ backgroundColor: "white", borderRadius: "16px", p: 3, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0" }}>
                      <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#1a1a1a", mb: 2 }}>
                        Attached Photos
                      </Typography>
                      <Stack gap={2}>
                        {order.images.map(({ url, caption }) => (
                          <Box key={url} sx={{ borderRadius: "12px", overflow: "hidden", border: "1px solid #f0f0f0" }}>
                            <img src={url} style={{ width: "100%", maxHeight: "240px", objectFit: "cover", display: "block" }} />
                            {caption && (
                              <Box sx={{ px: 2, py: 1.5, backgroundColor: "#fafafa" }}>
                                <Typography sx={{ fontSize: "13px", color: "#666" }}>{caption}</Typography>
                              </Box>
                            )}
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  )}

                  {/* ── Price Summary ── */}
                  <Box sx={{ backgroundColor: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0" }}>
                    <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #f5f5f5", backgroundColor: "#fafafa" }}>
                      <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#1a1a1a" }}>Price Summary</Typography>
                    </Box>
                    <Stack sx={{ px: 3, py: 2.5 }} gap={1.2}>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography sx={{ fontSize: "14px", color: "#666" }}>Service Amount</Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>${svcAmt.toFixed(2)}</Typography>
                      </Stack>
                      {items.map((addon, i) => (
                        <Stack key={i} direction="row" justifyContent="space-between">
                          <Typography sx={{ fontSize: "14px", color: "#666" }}>{addon.name}</Typography>
                          <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>${addon.price.toFixed(2)}</Typography>
                        </Stack>
                      ))}
                      <Box sx={{ height: "1px", backgroundColor: "#f0f0f0", my: 0.5 }} />
                      <Stack direction="row" justifyContent="space-between">
                        <Typography sx={{ fontSize: "14px", color: "#666" }}>Subtotal</Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>${subtotal.toFixed(2)}</Typography>
                      </Stack>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography sx={{ fontSize: "14px", color: "#666" }}>Tax (13%)</Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#1a1a1a" }}>${tax.toFixed(2)}</Typography>
                      </Stack>
                      <Box sx={{ height: "1px", backgroundColor: "#f0f0f0", my: 0.5 }} />
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#1a1a1a" }}>Total</Typography>
                        <Typography sx={{ fontSize: "20px", fontWeight: 700, color: themeOrange }}>${grandTotal.toFixed(2)}</Typography>
                      </Stack>
                    </Stack>

                    {order?.status !== "Completed" && (
                      <Box sx={{ px: 3, pb: 3 }}>
                        <Box
                          onClick={handlenavigation}
                          sx={{
                            background: "linear-gradient(135deg, #F15A24 0%, #C53F10 100%)",
                            color: "white", borderRadius: "12px", py: 1.6,
                            display: "flex", alignItems: "center", justifyContent: "center", gap: 1,
                            cursor: "pointer", fontWeight: 600, fontSize: "14px",
                            boxShadow: "0 4px 14px rgba(241,90,36,0.25)",
                            transition: "all 0.2s ease",
                            "&:hover": { transform: "translateY(-1px)", boxShadow: "0 6px 18px rgba(241,90,36,0.35)" },
                          }}
                        >
                          <FaPlus size={13} />
                          Add Additional Items
                        </Box>
                        <Typography sx={{ fontSize: "11px", color: "#bbb", textAlign: "center", mt: 1, lineHeight: 1.5 }}>
                          Contact the customer before adding extra charges
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* ── Complete Job Button ── */}
                  {order?.status === "Assigned" && (
                    <Box>
                      <Tooltip title={!completionStatus.canComplete ? completionStatus.reason : ""} placement="top" arrow>
                        <span>
                          <Box
                            onClick={completionStatus.canComplete && !isUpdatingJobStatus ? () => setConfirmOpen(true) : undefined}
                            sx={{
                              background: completionStatus.canComplete
                                ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                                : "#e5e5e5",
                              color: completionStatus.canComplete ? "white" : "#aaa",
                              borderRadius: "16px", py: 2,
                              display: "flex", alignItems: "center", justifyContent: "center", gap: 1,
                              cursor: completionStatus.canComplete && !isUpdatingJobStatus ? "pointer" : "not-allowed",
                              fontWeight: 700, fontSize: "16px",
                              boxShadow: completionStatus.canComplete ? "0 8px 24px rgba(16,185,129,0.3)" : "none",
                              transition: "all 0.2s ease",
                              "&:hover": completionStatus.canComplete ? { transform: "translateY(-2px)", boxShadow: "0 12px 28px rgba(16,185,129,0.35)" } : {},
                            }}
                          >
                            {isUpdatingJobStatus
                              ? <CircularProgress size={22} sx={{ color: "white" }} />
                              : "✓  Complete"}
                          </Box>
                        </span>
                      </Tooltip>
                      {!completionStatus.canComplete && (
                        <Typography sx={{ color: "#ef4444", fontSize: "12px", textAlign: "center", mt: 1 }}>
                          🕐 {completionStatus.reason}
                        </Typography>
                      )}
                    </Box>
                  )}

                  {/* ── Mobile negotiation panel ── */}
                  {isShownNegotiation && isMobile && (
                    <Box
                      ref={negotiationRef}
                      sx={{ backgroundColor: "white", borderRadius: "20px", overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0" }}
                    >
                      <Box sx={{ background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)", px: 3, py: 2.5 }}>
                        <Typography sx={{ color: "white", fontSize: "17px", fontWeight: 700 }}>Add Items</Typography>
                        <Typography sx={{ color: "rgba(255,255,255,0.45)", fontSize: "13px", mt: 0.3 }}>Extra charges for this job</Typography>
                      </Box>
                      <Box sx={{ p: 3 }}>
                        {NegotiationForm({})}
                      </Box>
                    </Box>
                  )}
                </Stack>
              </Grid>

              {/* ══════════ RIGHT — Desktop Add-Items Panel ══════════ */}
              {isShownNegotiation && !isMobile && (
                <Grid item xs={12} lg={4}>
                  <Box sx={{
                    backgroundColor: "white", borderRadius: "20px", overflow: "hidden",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f0f0f0",
                    position: "sticky", top: "24px",
                  }}>
                    <Box sx={{ background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)", px: 3, py: 2.5 }}>
                      <Typography sx={{ color: "white", fontSize: "17px", fontWeight: 700 }}>Add Items</Typography>
                      <Typography sx={{ color: "rgba(255,255,255,0.45)", fontSize: "13px", mt: 0.3 }}>Extra charges for this job</Typography>
                    </Box>
                    <Box sx={{ p: 3 }}>
                      {NegotiationForm({ inputRef: negotiationRef })}
                    </Box>
                  </Box>
                </Grid>
              )}

            </Grid>
          )}
        </Stack>
      </Container>

      {/* ── Confirm Complete Dialog ── */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        PaperProps={{ sx: { borderRadius: "16px", p: 1, maxWidth: "380px", width: "100%" } }}
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: "18px", color: "#1a1a1a" }}>
          Complete Job?
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: "14px", color: "#555", lineHeight: 1.7 }}>
            Are you sure you want to mark this job as complete? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            variant="outlined"
            sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 600, borderColor: "#e5e5e5", color: "#555", "&:hover": { borderColor: "#ccc" } }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => { setConfirmOpen(false); approveJob(); }}
            variant="contained"
            sx={{
              borderRadius: "10px", textTransform: "none", fontWeight: 600,
              background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
              boxShadow: "0 4px 14px rgba(16,185,129,0.3)",
              "&:hover": { background: "linear-gradient(135deg, #059669 0%, #047857 100%)" },
            }}
          >
            Yes, Complete
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default JobDoneDetails;
